import { createAsyncThunk } from '@reduxjs/toolkit';
import { StatusCodes } from 'http-status-codes';
import LineService from 'services/lineService';

export const getAllLines = createAsyncThunk(
  'lines/all',
  async (_, thunkAPI) => {
    try {
      const { status, data } = await LineService.getAllLines();
      if (status === StatusCodes.OK) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
